import React, { useEffect, useState } from 'react';
import UserDateInformationContainer from '../../../../common/UserDateInformationContainer';
import { isChemicalSafetyExpert } from '../../../../../behavior/init/selectors';

import { isCheckCseRequiredForChemRisk } from '../../../../../utils';
import useUser from '@behavior/init/getUserV2';
import { connect } from 'react-redux';

type Props = {
  values: any;
  disabled: boolean;
  setFieldValue: (name: string, value: any) => void;
  initialData: any;
  setValidateOnChange: (arg: boolean) => void;
  chemRiskLevelResultDto: any;
};

const IChemicalRiskCheckedCseInformationContainer = ({
  values,
  setFieldValue,
  initialData,
  setValidateOnChange,
  disabled,
  chemRiskLevelResultDto,
}: Props) => {
  const { user } = useUser();
  const isCSE = isChemicalSafetyExpert(user);
  const [riskCondition, setRiskCondition] = useState(
    isCheckCseRequiredForChemRisk(values.chemicalRiskAttributes)
  );

  useEffect(() => {
    if (chemRiskLevelResultDto?.chemRiskLevel?.id) {
      setRiskCondition(chemRiskLevelResultDto.chemRiskLevel.id > 3);
    }
  }, [chemRiskLevelResultDto]);

  return isCSE && riskCondition ? (
    <UserDateInformationContainer
      accordionTitle="inventory.details.page.cra.checked.cse.inf.container.title"
      userLabel="inventory.details.page.cra.checked.cse.inf.container.check.user.input"
      userName="chemicalRiskAttributes.checkCseUser"
      dteLabel="inventory.details.page.cra.checked.cse.inf.container.check.dte.input"
      dteName="chemicalRiskAttributes.checkCseDte"
      openDirection="up"
      setFieldValue={setFieldValue}
      initialData={initialData}
      setValidateOnChange={setValidateOnChange}
      disabled={disabled}
      values={values}
    />
  ) : null;
};

const mapStateToProps = (state: any) => ({
  chemRiskLevelResultDto: state.risksResult.chemRiskLevelResultDto,
});

export default connect(mapStateToProps)(React.memo(IChemicalRiskCheckedCseInformationContainer));
